import { AutocompleteInput } from "@/components/atoms/AutocompleteInput/AutocompleteInput";
import { MultiSelectDropdown } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdown";
import { GraphicsFilterEnum } from "@/modules/dashboard/domain/entities/DashboardEntity";
import { DashboardGraphicsFiltersProps } from "./DashboardGraphicsFilters.types";

export const DashboardGraphicsFilters = ({
    portfolioOptions,
    portfolio,
    setPortfolio,
    graphicsOptions,
    graphics,
    setGraphics,
}: DashboardGraphicsFiltersProps) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <AutocompleteInput
            label="Portafolio"
            options={portfolioOptions}
            value={portfolio}
            onSelect={(option) => setPortfolio(option.value)}
            placeholder="Buscar portafolio..."
            minCharacters={3}
        />
        <MultiSelectDropdown<GraphicsFilterEnum>
            label="Gráficos"
            options={graphicsOptions}
            value={graphics}
            onChange={setGraphics}
            selectLimit={3}
        />
    </div>
);